import React, {Component} from 'react';
import {Alert, Card, CardBody, CardSubtitle, CardTitle,} from 'reactstrap';

import {connect} from 'react-redux';
import {fetchCompanies} from '../../actions/companyActions';
import {updateCompanyAttributes} from '../../actions/attributesActions';
import {closeAlert} from '../../actions/commonsActions';
import {GUEST} from '../../helpers/constants';
import {I18n} from '../../I18n/components/companyClient';

import AttributesList from '../AttributesList/AttributesList';
import './companyClient.css';

class CompanyClient extends Component {
	constructor(props) {
		super(props);
		this.state = {
			newCompany: {
				id: null,
				name: '',
				types: '',
				country: '',
				city: '',
				manager: '',
				phone: '',
				email: '',
				skype: '',
				status: ''
			}
		};
	}

	componentDidMount() {
		this.props.fetchCompanies().then(res => {
			if (res) {
				this.setState({
					newCompany: this.props.companies[0],
				});
			}
		})
	}


	updateCompanyAttributesList = async attributes => {
		await this.props.updateCompanyAttributes(attributes);
		setTimeout(() => {
			this.props.closeAlert();
		}, 3000);
	};

	render() {
		const { attributes } =  this.state.newCompany;
		const {lang} = this.props;
		return (
			<div>
				{/*----------------------- alerts -----------------------------------*/}
				<Alert
					color={`${this.props.alert.alert.status}`}
					isOpen={this.props.alert.isOpen || false}
				>
					{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
				</Alert>

				<Card>
					<CardTitle className="mb-0 p-3 border-bottom bg-light">
						<div>
							<i className="mdi mdi-border-right mr-2"></i>{I18n[lang].client}
						</div>
					</CardTitle>
					<CardSubtitle className="companyClient__downloadLink">
						<a
							href="http://pa.hankuper.com/update_test/publish.htm"
							alt={I18n[lang].downloadLink}
							target="_blank"
							rel="noreferrer"
							rel="noopener"
						>{I18n[lang].downloadLink}</a>
					</CardSubtitle>
					<CardBody>
						{
							attributes && attributes.length ? (
								<div>
									<CardSubtitle>{I18n[lang].companyAttributes}</CardSubtitle>
									<AttributesList
										attributes={this.state.newCompany.attributes ? this.state.newCompany.attributes : []}
										isAttributesChangingAllowed={true}
										updateAttributesList={this.updateCompanyAttributesList}
										authority={this.props.authority}
										isTypeShown={false}
									/>
								</div>
							) : ""
						}
					</CardBody>
				</Card>
			</div>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
		fetchCompanies: query => dispatch(fetchCompanies(query)),
		closeAlert: () => dispatch(closeAlert()),
		updateCompanyAttributes: attributes => dispatch(updateCompanyAttributes(attributes))
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	companies: state.companiesReducer.companies,
	authority:  state.currentUser.roles[0].authority || GUEST,
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyClient)



// WEBPACK FOOTER //
// ./src/components/CompanyClient/CompanyClient.js